import { gql } from '@apollo/client';

/**
 * Shared selections.
 *
 * The join tables are gone: `UserCohort { cohort { name } }` is now just
 * `cohorts { name }`, and the same for subjects. Keeping the selection in one
 * place means the shape the views destructure is defined once.
 */
export const USER_SUMMARY = gql`
  fragment UserSummary on User {
    id
    firstName
    lastName
    email
    userName
    role
    accountType
    status
  }
`;

export const USER_ENROLMENTS = gql`
  fragment UserEnrolments on User {
    cohorts {
      id
      name
    }
    subjects {
      id
      name
      cohortId
    }
  }
`;

export const USER_PROFILES = gql`
  fragment UserProfiles on User {
    profileStudent {
      admissionNumber
      profileImg
      gender
      dob
      state
      zipCode
      country
      parentName
      parentPhoneNumber
      address
    }
    profileTeacher {
      profileImg
      gender
      address
      phoneNumber
      state
      zipCode
      country
      kinName
      kinPhoneNumber
      kinAddress
      doe
    }
  }
`;

/**
 * `url` is a signed link that expires, so it is read per request and never
 * stored — see the uploads section of docs/api-migration-map.md.
 */
export const UPLOAD_FIELDS = gql`
  fragment UploadFields on Upload {
    id
    filename
    mimetype
    url
    desc
  }
`;

/**
 * Everything the cohort list renders.
 *
 * Shared between the list query and `createCohort`, because the mutation's
 * result is written into the list's cache entry: a field selected there and
 * not here makes Apollo refuse the write outright.
 */
export const COHORT_SUMMARY = gql`
  fragment CohortSummary on Cohort {
    id
    name
    description
    createdAt
    creator {
      id
      firstName
      lastName
    }
    subjects {
      id
      name
    }
  }
`;
